import styled, { DefaultTheme, css } from 'styled-components';

type LabelProps = {
  variant: 'primary' | 'secondary' | 'third';
};

const labelModifiers = (theme: DefaultTheme) => ({
  primary: css`
    width: 56px;
    height: 56px;
    background-color: ${theme.colors.globalWhite100};
    border-radius: 4px;
    cursor: pointer;
    position: relative;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      font-weight: 600;
      font-size: 1.6rem;
      line-height: 2.6rem;
      color: ${theme.colors.neutralSilver90};
    }

    input {
      width: 100%;
      height: 100%;
      appearance: none;
      -webkit-appearance: none;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid ${theme.colors.neutralSilver20};

      &:checked {
        border-color: ${theme.colors.brandPrimary100};
      }

      &:checked + div > span {
        color: ${theme.colors.brandPrimary100};
      }
    }

    @media (max-width: 768px) {
      height: 48px;
      width: 48px;
    }
  `,
  secondary: css`
    display: flex;
    align-items: center;
    gap: 16px;
    cursor: pointer;

    span {
      font-weight: 400;
      font-size: 1.6rem;
      line-height: 2.6rem;
      color: ${theme.colors.neutralSilver70};
    }

    input {
      width: 24px;
      height: 24px;
      cursor: pointer;

      accent-color: ${theme.colors.brandPrimary70};

      &:checked + div > span {
        font-weight: 500;
      }
    }
  `,
  third: css`
    width: 256px;
    height: 48px;
    border-radius: 4px;
    cursor: pointer;
    position: relative;

    svg {
      margin-right: 8px;
    }

    span {
      font-weight: 600;
      font-size: 1.6rem;
      line-height: 2.6rem;
    }

    input {
      width: 100%;
      height: 100%;
      appearance: none;
      -webkit-appearance: none;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid ${theme.colors.neutralSilver30};

      &:checked {
        border-color: ${theme.colors.brandPrimary70};
        border: 1px solid ${theme.colors.brandPrimary70};
      }

      &:checked + div {
        > span,
        svg {
          color: ${theme.colors.brandPrimary100};
        }
      }
    }

    div {
      width: 100%;
      padding: 12px;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      color: ${theme.colors.neutralSilver90};
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
    }

    @media (max-width: 576px) {
      width: 164px;
    }

    @media (max-width: 375px) {
      width: 100%;
    }
  `,
});

export const Label = styled.label<LabelProps>`
  ${({ theme, variant }) => css`
    ${labelModifiers(theme)[variant]}
  `}
`;
